import { Outlet } from "react-router-dom";
import { useAnalytics } from "../analytics/useAnalytics";
import { ConnectionOverlay } from "./ConnectionOverlay";
import { Footer } from "./Footer";
import { Header } from "./Header";
import styles from "./Layout.module.css";

export function Layout() {
    useAnalytics();
    return (
        <div className={styles.layout}>
            <Header />
            <main className={styles.main}>
                <Outlet />
            </main>
            <Footer />
            <ConnectionOverlay />
        </div>
    );
}
